<template>
  <!-- 用户签到设置 -->
  <div class="set-sign-in">
    <!-- header头部 -->
    <header>
      <el-button size="small" type="primary" @click="openAddSign(0)"
        >添加签到</el-button
      >
      <el-button size="small" type="primary" @click="openSignIn()"
        >签到次数对应的金额</el-button
      >
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="signList" v-loading="loading">
        <el-table-column
          prop="box_id"
          label="盒子id"
          align="center"
          :sortable="true"
        >
        </el-table-column>
        <el-table-column
          prop="num"
          label="盒子数量"
          align="center"
          :sortable="true"
        >
        </el-table-column>
        <el-table-column
          prop="score_rule_mini"
          label="最低等级"
          align="center"
          :sortable="true"
        >
        </el-table-column>
        <el-table-column
          prop="score_rule_max"
          label="最高等级"
          align="center"
          :sortable="true"
        >
        </el-table-column>
        <el-table-column
          prop="cycle"
          label="累积签到次数"
          align="center"
          :sortable="true"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="openAddSign(1, row)"
              >编辑</el-button
            >
            <el-button type="danger" size="small" @click="deleteSign(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <!-- 编辑分组信息 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="dialogType === 0 ? '添加签到信息' : '编辑签到信息'"
      width="400px"
      center
    >
      <el-form
        v-if="signForm"
        :model="signForm"
        ref="signForm"
        label-width="100px"
        size="small"
        :rules="signRules"
      >
        <el-form-item prop="box_id" label="盒子ID">
          <el-select v-model="signForm.box_id">
            <el-option :value="132" label="红色西瓜箱 "></el-option>
            <el-option :value="287" label="M9注册福利宝箱"></el-option>
            <el-option :value="256" label="狂牙箱子"></el-option>
            <el-option :value="126" label="1-20级箱子"></el-option>
            <el-option :value="127" label="21-40级箱子"></el-option>
            <el-option :value="128" label="41-60级箱子"></el-option>
            <el-option :value="129" label="61-80级箱子"></el-option>
            <el-option :value="130" label="81-100级箱子"></el-option>
            <el-option :value="131" label="101级箱子"></el-option>
            <el-option :value="495" label="蓝靛果子箱"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="num" label="盒子数量">
          <el-input v-model="signForm.num"></el-input>
        </el-form-item>
        <el-form-item label="用户等级">
          <el-input
            style="width: 100px"
            v-model="signForm.score_rule_mini"
            placeholder="最小等级"
          ></el-input>
          -
          <el-input
            style="width: 100px"
            v-model="signForm.score_rule_max"
            placeholder="最大等级"
          ></el-input>
        </el-form-item>
        <el-form-item prop="cycle" label="签到次数">
          <el-input v-model="signForm.cycle"></el-input>
        </el-form-item>
        <el-form-item prop="recharge_requirements" label="签到满额充值要求">
          <el-input v-model="signForm.recharge_requirements"></el-input>
        </el-form-item>
        <el-form-item prop="is_show" label="满额赠送">
          <el-select v-model="signForm.is_show">
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="send_box"
          label="赠送盒子"
          v-if="signForm.is_show === 1"
        >
          <el-select v-model="signForm.send_box">
            <el-option :value="407" label="感恩箱"></el-option>
            <el-option :value="132" label="红色西瓜箱 "></el-option>
            <el-option :value="287" label="M9注册福利宝箱"></el-option>
            <el-option :value="256" label="狂牙箱子"></el-option>
            <el-option :value="126" label="1-20级箱子"></el-option>
            <el-option :value="127" label="21-40级箱子"></el-option>
            <el-option :value="128" label="41-60级箱子"></el-option>
            <el-option :value="129" label="61-80级箱子"></el-option>
            <el-option :value="130" label="81-100级箱子"></el-option>
            <el-option :value="131" label="101级箱子"></el-option>
            <el-option :value="495" label="蓝靛果子箱"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="send_num"
          label="赠送数量"
          v-if="signForm.is_show === 1"
        >
          <el-input v-model="signForm.send_num"></el-input>
        </el-form-item>
        <el-form-item
          prop="send_day"
          label="满额天数"
          v-if="signForm.is_show === 1"
        >
          <el-input v-model="signForm.send_day"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 编辑签到7、14次时需要充值的金额 -->
    <el-dialog
      :visible.sync="signInVisible"
      :close-on-click-modal="false"
      title="编辑签到次数对应的金额信息"
      width="400px"
      center
    >
      <el-form
        v-if="editSignInForm"
        :model="editSignInForm"
        ref="editSignInForm"
        label-width="140px"
        size="small"
        :rules="signRules"
      >
        <el-form-item label="签到7次需充值">
          <el-input v-model="editSignInForm.seven"></el-input>
        </el-form-item>
        <el-form-item label="签到14次需充值">
          <el-input v-model="editSignInForm.fourteen"></el-input>
        </el-form-item>
        <el-form-item label="签到21次需充值">
          <el-input v-model="editSignInForm.twentyOne"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="signInVisible = false">取消</el-button>
          <el-button type="primary" @click="editSignIn" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapActions,
  mapState,
  mapGetters
} from 'vuex'
import {
  patchData,
  postData,
  getApiData,
  patchApiData,
  postApiData,
  delApiData
} from '@/http'
export default {
  data() {
    return {
      signInVisible: false, //编辑签到次数对应的金额信息
      dialogVisible: false, //添加/编辑显示弹窗
      buttonLoading: false, //按钮动画
      loading: false, //加载动画
      signList: [],
      dialogType: 0, //弹窗类型 0是添加 1是编辑
      signForm: {
        box_id: undefined, //盒子id
        num: undefined, //盒子数量
        score_rule_mini: undefined, //最低等级
        score_rule_max: undefined, //最高等级
        cycle: undefined, //需要达到的签到的次数
        recharge_requirements: 0,//签到满额充值要求
        is_show: undefined, //此规则是否满额增送 0是，1否
        send_box: undefined, //满额赠送的盒子id
        send_num: undefined, //满额赠送的盒子的数量
        send_day: undefined, //满额赠送的天数
      },
      editSignInForm: {
        seven: 0,
        fourteen: 0,
        twentyOne: 0
      },
      signRules: {
        box_id: [{
          required: true,
          message: '请选择盒子'
        }],
        num: [{
          required: true,
          message: '请输入盒子数量',
          trigger: 'blur'
        }],
        cycle: [{
          required: true,
          message: '请输入签到要达到的次数'
        }],
        is_show: [{
          required: true,
          message: '请选择是否满额赠送'
        }],
        send_box: [{
          required: true,
          message: '请选择满额赠送的盒子'
        }],
        send_num: [{
          required: true,
          message: '请选择满额赠送的盒子的数量'
        }],
        send_day: [{
          required: true,
          message: '请选择满额赠送的天数'
        }],
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      //获取签到列表
      this.loading = true
      getApiData('sign').then((res) => {
        if (res) {
          this.signList = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openAddSign(val, rowInfo) {
      //打开签到弹窗
      if (val === 1) {
        this.signForm = JSON.parse(JSON.stringify(rowInfo))
      } else {
        this.signForm = {
          box_id: undefined, //盒子id
          num: undefined, //盒子数量
          score_rule_mini: undefined, //最低等级
          score_rule_max: undefined, //最高等级
          cycle: undefined, //需要达到的签到的次数
          recharge_requirements: 0,//签到满额充值要求
          is_show: undefined, //此规则是否显示 0是显示，1是隐藏
          send_box: undefined, //满额赠送的盒子id
          send_num: undefined, //满额赠送的盒子的数量
          send_day: undefined, //满额赠送的天数
        }
      }
      this.dialogType = val
      this.dialogVisible = true
    },
    async openSignIn() {
      await this.getSignIn()
      this.signInVisible = true
    },
    submit() {
      // 保存添加/编辑的规则
      //提交表单
      this.$refs['signForm'].validate((valid) => {
        if (valid) {
          if (!this.signForm.score_rule_mini || !this.signForm.score_rule_max) {
            this.$message.error('用户最小等级和最大等级必填')
            return
          } else if (Number(this.signForm.score_rule_mini) < 1) {
            this.$message.error('用户最小等级不能小于1级')
            return
          }

          if (this.signForm.num <= 0) {
            this.$message.error('盒子数量必须大于0')
            return
          }

          if (this.signForm.cycle <= 0) {
            this.$message.error('签到次数必须大于0')
            return
          }

          if (this.signForm.send_num <= 0) {
            this.$message.error('赠送盒子数量必须大于0')
            return
          }

          if (this.signForm.send_day <= 0) {
            this.$message.error('满额天数必须大于0')
            return
          }


          let params = this.signForm
          this.buttonLoading = true
          if (this.dialogType === 0) {
            postApiData('sign', params).then((res) => {
              this.$message.success('添加成功')
              this.dialogVisible = false
              this.getData() //刷新数据
            }).finally(() => {
              this.buttonLoading = false
            })
          } else if (this.dialogType === 1) {
            patchApiData('sign', params).then((res) => {
              this.$message.success('编辑成功')
              this.dialogVisible = false
              this.getData() //刷新数据
            }).finally(() => {
              this.buttonLoading = false
            })

          }
        }
      })
    },
    getSignIn() {
      getApiData('sign_receive_limit').then((res) => {
        this.editSignInForm.seven = res[0].recharge
        this.editSignInForm.fourteen = res[1].recharge
        this.editSignInForm.twentyOne = res[2].recharge
      })
    },
    editSignIn() {
      //编辑签到次数对应的金额信息
      let params = [
        {
          days: 7,
          recharge: this.editSignInForm.seven
        },
        {
          days: 14,
          recharge: this.editSignInForm.fourteen
        },
        {
          days: 21,
          recharge: this.editSignInForm.twentyOne
        },
      ]
      this.buttonLoading = true
      postApiData('sign_receive_limit', { params }).then((res) => {
        this.$message.success('保存成功')
        this.signInVisible = false
      }).finally(() => {
        this.buttonLoading = false
      })

    },
    deleteSign(rowInfo) {
      this.$confirm('确认删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delApiData(`sign/${rowInfo.id}`).then(res => {
          this.$message.success('删除成功')
          this.getData() //刷新数据
        })
      }).catch(() => { })
    }
  }

}

</script>
<style lang="less" scoped>
</style>
